var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M7.544-13.766A.744.744,0,0,0,7-14a.744.744,0,0,0-.544.234l-4.25,4.5a.75.75,0,0,0-.144.813A.751.751,0,0,0,2.75-8H5v4A1,1,0,0,0,6-3H8A1,1,0,0,0,9-4V-8h2.25a.748.748,0,0,0,.688-.453.75.75,0,0,0-.144-.812ZM2-3A1,1,0,0,0,1-4,1,1,0,0,0,0-3v2A3,3,0,0,0,3,2h8a3,3,0,0,0,3-3V-3a1,1,0,0,0-1-1,1,1,0,0,0-1,1v2a1,1,0,0,1-1,1H3A1,1,0,0,1,2-1Z",
    transform: "translate(0 14)",
    fill: "#ff4e00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadIcon);
export default __webpack_public_path__ + "static/media/fileUploadIcon.d2ef5889a10b95117b695f9c3545e85b.svg";
export { ForwardRef as ReactComponent };